import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import TableRow from 'components/atoms/TableRow'
import TablePlaceholder from 'components/atoms/TablePlaceholder'

const styles = () => ({
  root: {},
})

const TableBody = ({
  classes,
  columns,
  onRowClick,
  onItemSelect,
  dataProvider,
  emptyStateTitle,
  emptyStateLinkTo,
  rowComponentProps,
  emptyStateLinkLabel,
  emptyStateDescription,
  noPlaceholder,
  RowComponent,
  handleShare,
}) => (
  <div className={classes.root}>
    {dataProvider && Object.keys(dataProvider)[0] ? (
      Object.keys(dataProvider).map((row, index) =>
        (RowComponent ? (
          <RowComponent
            key={index}
            data={dataProvider[row]}
            columns={columns}
            {...rowComponentProps}
          />
        ) : (
          <TableRow
            key={index}
            columns={columns}
            onClick={onRowClick}
            className={classes.row}
            data={dataProvider[row]}
            isValid={row !== 'null'}
            onItemSelect={onItemSelect}
            handleShare={handleShare}
            {...rowComponentProps}
          />
        )))
    ) : (
      !noPlaceholder &&
      <TablePlaceholder
        title={emptyStateTitle}
        text={emptyStateDescription}
        linkTo={emptyStateLinkTo}
        linkLabel={emptyStateLinkLabel}
      />
    )}
  </div>
) 


TableBody.propTypes = {
  columns: PropTypes.array,
  classes: PropTypes.object,
  onRowClick: PropTypes.func,
  onItemSelect: PropTypes.func,
  handleShare: PropTypes.func,
  RowComponent: PropTypes.object,
  dataProvider: PropTypes.object,
  emptyStateTitle: PropTypes.string,
  emptyStateLinkTo: PropTypes.string,
  rowComponentProps: PropTypes.object,
  emptyStateLinkLabel: PropTypes.string,
  emptyStateDescription: PropTypes.string,
  noPlaceholder: PropTypes.bool,
}

export default withStyles(styles)(TableBody)



// WEBPACK FOOTER //
// ./src/components/molecules/TableBody.js